import { ReactNode } from 'react';
import { useIsStaff } from '../../hooks/use-is-staff';

type CimplicoStaffGuardProps = {
    children: ReactNode | ReactNode[];
};

/**
A React component that guards against unauthorized access by checking if the current user is a staff member.
@returns The children if the user is a staff member, or null otherwise.
 */
function CimplicoStaffGuard({ children }: CimplicoStaffGuardProps): JSX.Element | null {
    const isStaff = useIsStaff();

    if (isStaff) {
        return <>{children}</>;
    }

    return null;
}

export default CimplicoStaffGuard;
